<template>
  <div class="mb-60px flex flex-col text-center">
    <PtcPicture
      v-if="cardImage?.asset?._ref"
      provider="sanity"
      :src="cardImage?.asset._ref"
      :alt="resolvedImage?.altText || 'Designer Card Image'"
      :modifiers="{
        crop: cardImage?.crop,
        hotspot: cardImage?.hotspot,
        w: 104,
        h: 100,
      }"
      :quality="75"
      :img-attrs="{
        class: { 'w-104px mx-auto h-100px': true },
      }"
    />
    <h4
      :class="{
        'mb-18px mt-10px flex h-12 items-end justify-center text-lg font-bold uppercase leading-6 text-www-color-neutral-medium-dark md:mt-14': true,
      }"
    >
      {{ title }}
    </h4>
    <p
      :class="{
        'flex-grow text-lg leading-6 text-www-color-neutral-medium-dark': true,
      }"
    >
      {{ description }}
    </p>
    <GeneralLink
      v-if="link"
      :class="{
        'h-12 font-ptc-Rajdhani text-base font-bold uppercase leading-7 text-www-color-primary-light hover:underline md:text-xs xl:text-base': true,
      }"
      v-bind="{
        ...link,
        _type: 'generalLink',
      }"
    />
  </div>
</template>

<script lang="ts" setup>
import PtcPicture from '~/components/Atoms/PtcPicture/PtcPicture.vue';
import GeneralLink from '~/components/Molecules/HeaderComponents/GeneralLink.vue';
import type { ManualCard } from '~/sanity/types';
const props = defineProps<ManualCard>();
const { getResolvedImage } = useRefsStore();
const resolvedImage = await getResolvedImage(props.cardImage?.asset?._ref);
</script>

<style></style>
